export default `
query me{ 
  me{
      email
      }
  }
`;
